module.exports = __webpack_public_path__ + "static/media/digitality.e5481c26.svg";